import React from "react";
import InputTextComp from "@components/UI/InputText/Index";
import { formatDateToBR } from "@utils/FormatDate";

function ViewerData({ solicitacaoFields, unidadeGerenciaFields, nomeAuditor, loading, error }) {

    if (loading) {
        return <p>Carregando dados...</p>;
    }
    if (error) {
        return <p>Ocorreu um erro: {error.message}</p>;
    }
    if (!solicitacaoFields) {
        return <p>Nenhum dado da solicitação encontrado.</p>;
    }

    const {
        numeroSolicitacao,
        dataSolicitacao,
        dataLimiteSolicitacao,
        observacoes
    } = solicitacaoFields;

    const {
        nome,
        nomeGerente,
        nomeEncarregado,
    } = unidadeGerenciaFields;

    return (
        <div className="form">
            <div className="col-md-12">
                <div className="row mt-3">

                    {/* Coluna Esquerda */}
                    <div className="col-5 col-md-5 p-0">
                        <InputTextComp
                            label="Solicitação Nº"
                            hoverMessage="Número da Solicitação"
                            value={numeroSolicitacao}
                            placeholder="-"
                            required
                            disabled
                        />

                        <InputTextComp
                            label="Data Solicitação"
                            hoverMessage="Data em que a solicitação foi criada"
                            value={formatDateToBR(dataSolicitacao)}
                            placeholder="-"
                            required
                            disabled
                        />

                        <InputTextComp
                            label="Data Limite"
                            hoverMessage="Data limite para responder a solicitação"
                            value={formatDateToBR(dataLimiteSolicitacao)}
                            placeholder="-"
                            required
                            disabled
                        />

                        <InputTextComp
                            label="Unidade/Gerência"
                            hoverMessage="Nome da Unidade/Gerência"
                            value={nome}
                            placeholder="-"
                            required
                            disabled
                        />

                        <InputTextComp
                            label="Nome Gerente"
                            hoverMessage="Nome do(a) Gerente(a) da Unidade/Gerência"
                            value={nomeGerente}
                            placeholder="-"
                            required
                            disabled
                        />

                        <InputTextComp
                            label="Nome Encarregado"
                            hoverMessage="Nome do(a) Encarregado(a) Unidade/Gerência"
                            value={nomeEncarregado}
                            placeholder="-"
                            required
                            disabled
                        />
                    </div>

                    {/* Coluna Direita */}
                    <div className="col-7 col-md-7 p-0">

                        <InputTextComp
                            label="Auditor Responsável"
                            hoverMessage="Nome do(a) Auditor(a) Responsável"
                            value={nomeAuditor}
                            placeholder="-"
                            required
                            disabled
                        />

                        <div className="mt-4 mx-1 py-3">
                            <h2 className="mb-1">Observações (Texto Simples)</h2>
                        </div>

                        <div className="mt-1">
                            <textarea
                                className={`form-control text dark`}
                                value={observacoes ?? 'Nenhuma observação existente.'}
                                title="Observações(Texto Simples). Campo Opcional."
                                style={{ height: '8rem', resize: 'none' }}
                                maxLength={256}
                                disabled
                            />
                        </div>

                    </div>

                </div>
            </div>
        </div>
    );
};

export default ViewerData;
